<template>
  <section class="staking-form-section">
    <h2 class="section-title">
      <span>获取RUSD收益</span>
      <span
        class="iconfont icon-fenxiang share-btn"
        @click="onShare"
      />
    </h2>
    <div class="form-card">
      <div class="form-item">
        <label class="form-label">参与金额</label>
        <div class="input-wrap">
          <input
            v-model="amount"
            type="number"
            class="form-input"
            :placeholder="amountPlaceholder"
            :disabled="submitting"
          />
          <div class="input-suffix">
            <span class="unit">USDT</span>
            <img src="@/assets/image/USDT.png" alt="USDT" class="usdt-icon" />
          </div>
        </div>
      </div>

      <div class="form-item">
        <label class="form-label">质押时间</label>
        <div class="select-wrap" @click="openPicker">
          <span class="select-value">{{ selectedDurationLabel }}</span>
          <span class="chevron" />
        </div>
      </div>

      <p class="referral">
        上级地址: {{ displayParentAddress }}
      </p>

      <button
        class="submit-btn"
        :class="{ loading: submitting }"
        :disabled="submitting"
        @click="onSubmit"
      >
        {{ submitting ? "提交中..." : "立即参与" }}
      </button>
    </div>

    <div v-if="showPicker" class="picker-mask" @click="showPicker = false">
      <div class="picker-panel" @click.stop>
        <div
          v-for="option in durationOptions"
          :key="option.value"
          class="picker-item"
          :class="{ active: duration === option.value }"
          @click="selectDuration(option)"
        >
          {{ option.label }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { Notify } from "vant";
import { STAKING_DURATION_OPTIONS } from "../config";
import { shortenAddress, buildPledgeInviteUrl, copyText } from "@/utils/utils";

export default {
  props: {
    parentAddress: {
      type: String,
      default: "",
    },
    minDeposit: {
      type: String,
      default: "",
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      amount: "",
      duration: 180,
      durationOptions: STAKING_DURATION_OPTIONS,
      showPicker: false,
    };
  },
  computed: {
    ...mapGetters(["accountAddress"]),
    selectedDurationLabel() {
      const option = this.durationOptions.find((item) => item.value === this.duration);
      return option ? option.label : "";
    },
    amountPlaceholder() {
      if (this.minDeposit) {
        return `输入金额, 最小${this.minDeposit} USDT`;
      }
      return "输入金额";
    },
    displayParentAddress() {
      if (!this.parentAddress) {
        return "未绑定";
      }
      return shortenAddress(this.parentAddress);
    },
  },
  methods: {
    openPicker() {
      if (this.submitting) return;
      this.showPicker = true;
    },
    selectDuration(option) {
      this.duration = option.value;
      this.showPicker = false;
    },
    onSubmit() {
      if (this.submitting) return;
      this.$emit("submit", {
        amount: this.amount,
        duration: this.duration,
      });
    },
    async onShare() {
      if (!this.accountAddress) {
        Notify({ type: "warning", message: "请先连接钱包后再分享" });
        return;
      }
      const inviteUrl = buildPledgeInviteUrl(this.accountAddress);
      const copied = await copyText(inviteUrl);
      if (copied) {
        Notify({ type: "success", message: "推广链接已复制" });
      } else {
        Notify({ type: "warning", message: "复制失败，请手动复制链接" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.staking-form-section {
  padding: 0 30px 24px;
}

.section-title {
  margin: 0 0 16px;
  font-size: 30px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .share-btn {
    font-size: 40px;
    cursor: pointer;
    transition: opacity 0.2s;

    &:active {
      opacity: 0.7;
    }
  }
}

.form-card {
  padding: 20px;
  border-radius: 16px;
  background: #040a28;
}

.form-item {
  margin-bottom: 16px;
}

.form-label {
  display: block;
  margin-bottom: 10px;
  font-size: 26px;
  color: rgba(255, 255, 255, 0.85);
}

.input-wrap,
.select-wrap {
  display: flex;
  align-items: center;
  height: 72px;
  padding: 0 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.form-input {
  flex: 1;
  min-width: 0;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 26px;
  color: #fff;

  &::placeholder {
    color: rgba(255, 255, 255, 0.35);
  }
}

.input-suffix {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-left: 12px;

  .unit {
    font-size: 26px;
    color: rgba(255, 255, 255, 0.7);
  }

  .usdt-icon {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }
}

.select-wrap {
  justify-content: space-between;
  cursor: pointer;

  .select-value {
    font-size: 26px;
    color: #fff;
  }

  .chevron {
    width: 10px;
    height: 10px;
    border-right: 2px solid rgba(255, 255, 255, 0.6);
    border-bottom: 2px solid rgba(255, 255, 255, 0.6);
    transform: rotate(45deg);
  }
}

.referral {
  margin: 0 0 20px;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.5);
}

.submit-btn {
  width: 100%;
  height: 72px;
  border: none;
  border-radius: 36px;
  font-size: 28px;
  color: #fff;
  background: #7338ff;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:active:not(:disabled) {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.picker-mask {
  position: fixed;
  inset: 0;
  z-index: 200;
  display: flex;
  align-items: flex-end;
  background: rgba(0, 0, 0, 0.5);
}

.picker-panel {
  width: 100%;
  padding: 16px 0 32px;
  border-radius: 16px 16px 0 0;
  background: #040a28;
}

.picker-item {
  padding: 16px 30px;
  font-size: 28px;
  color: rgba(255, 255, 255, 0.75);
  text-align: center;
  cursor: pointer;

  &.active {
    color: #7338ff;
  }

  &:active {
    background: rgba(255, 255, 255, 0.05);
  }
}
</style>
